'use client';

import { ErrorBoundaryPage } from '@/components/shared/error-boundary-page';

interface ErrorProps {
  error: Error & { digest?: string };
  reset: () => void;
}

/** Shared body — see ``src/components/shared/error-boundary-page.tsx``. */
export default function AppError({ error, reset }: ErrorProps) {
  return (
    <ErrorBoundaryPage
      error={error}
      reset={reset}
      area="App"
      description="Beklenmedik bir hata oluştu. Lütfen tekrar deneyin."
    />
  );
}
